export class DataCatalogDiscoveryProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "scanJobId",
            "baseName": "scanJobId",
            "type": "string",
            "format": ""
        },
        {
            "name": "scannedAt",
            "baseName": "scannedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogDiscoveryProperties.attributeTypeMap;
    }
    constructor() {
    }
}
